module.exports = ".re-sync--date {\n  margin-right: 10px;\n  color: #acacaf; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/buttons/re-sync-btn/re-sync-btn.scss
// module id = ./web/modern/components/buttons/re-sync-btn/re-sync-btn.scss
// module chunks = 0